"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgSetModulePausedResponse = exports.MsgSetModulePaused = exports.MsgUpdateWhitelistedValidatorsResponse = exports.MsgUpdateWhitelistedValidators = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgLiquidUnstakeResponse = exports.MsgLiquidUnstake = exports.MsgStakeToLPResponse = exports.MsgStakeToLP = exports.MsgLiquidStakeResponse = exports.MsgLiquidStake = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const liquidstake_1 = require("./liquidstake");
const timestamp_1 = require("../../../google/protobuf/timestamp");
const binary_1 = require("../../../binary");
const helpers_1 = require("../../../helpers");
exports.protobufPackage = "pstake.liquidstake.v1beta1";
function createBaseMsgLiquidStake() {
    return {
        delegatorAddress: "",
        amount: coin_1.Coin.fromPartial({}),
    };
}
exports.MsgLiquidStake = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgLiquidStake();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseMsgLiquidStake();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        if ((0, helpers_1.isSet)(object.amount))
            obj.amount = coin_1.Coin.fromJSON(object.amount);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgLiquidStake();
        message.delegatorAddress = object.delegatorAddress ?? "";
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin_1.Coin.fromPartial(object.amount);
        }
        return message;
    },
};
function createBaseMsgLiquidStakeResponse() {
    return {};
}
exports.MsgLiquidStakeResponse = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgLiquidStakeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseMsgLiquidStakeResponse();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgLiquidStakeResponse();
        return message;
    },
};
function createBaseMsgStakeToLP() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        stakedAmount: coin_1.Coin.fromPartial({}),
        liquidAmount: coin_1.Coin.fromPartial({}),
    };
}
exports.MsgStakeToLP = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.stakedAmount !== undefined) {
            coin_1.Coin.encode(message.stakedAmount, writer.uint32(26).fork()).ldelim();
        }
        if (message.liquidAmount !== undefined) {
            coin_1.Coin.encode(message.liquidAmount, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgStakeToLP();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.stakedAmount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.liquidAmount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseMsgStakeToLP();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        if ((0, helpers_1.isSet)(object.validatorAddress))
            obj.validatorAddress = String(object.validatorAddress);
        if ((0, helpers_1.isSet)(object.stakedAmount))
            obj.stakedAmount = coin_1.Coin.fromJSON(object.stakedAmount);
        if ((0, helpers_1.isSet)(object.liquidAmount))
            obj.liquidAmount = coin_1.Coin.fromJSON(object.liquidAmount);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.stakedAmount !== undefined &&
            (obj.stakedAmount = message.stakedAmount ? coin_1.Coin.toJSON(message.stakedAmount) : undefined);
        message.liquidAmount !== undefined &&
            (obj.liquidAmount = message.liquidAmount ? coin_1.Coin.toJSON(message.liquidAmount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgStakeToLP();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        if (object.stakedAmount !== undefined && object.stakedAmount !== null) {
            message.stakedAmount = coin_1.Coin.fromPartial(object.stakedAmount);
        }
        if (object.liquidAmount !== undefined && object.liquidAmount !== null) {
            message.liquidAmount = coin_1.Coin.fromPartial(object.liquidAmount);
        }
        return message;
    },
};
function createBaseMsgStakeToLPResponse() {
    return {};
}
exports.MsgStakeToLPResponse = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgStakeToLPResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseMsgStakeToLPResponse();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgStakeToLPResponse();
        return message;
    },
};
function createBaseMsgLiquidUnstake() {
    return {
        delegatorAddress: "",
        amount: coin_1.Coin.fromPartial({}),
    };
}
exports.MsgLiquidUnstake = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgLiquidUnstake();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseMsgLiquidUnstake();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        if ((0, helpers_1.isSet)(object.amount))
            obj.amount = coin_1.Coin.fromJSON(object.amount);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgLiquidUnstake();
        message.delegatorAddress = object.delegatorAddress ?? "";
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin_1.Coin.fromPartial(object.amount);
        }
        return message;
    },
};
function createBaseMsgLiquidUnstakeResponse() {
    return {
        completionTime: timestamp_1.Timestamp.fromPartial({}),
    };
}
exports.MsgLiquidUnstakeResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgLiquidUnstakeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseMsgLiquidUnstakeResponse();
        if ((0, helpers_1.isSet)(object.completionTime))
            obj.completionTime = (0, helpers_1.fromJsonTimestamp)(object.completionTime);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.completionTime !== undefined &&
            (obj.completionTime = (0, helpers_1.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgLiquidUnstakeResponse();
        if (object.completionTime !== undefined && object.completionTime !== null) {
            message.completionTime = timestamp_1.Timestamp.fromPartial(object.completionTime);
        }
        return message;
    },
};
function createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: liquidstake_1.Params.fromPartial({}),
    };
}
exports.MsgUpdateParams = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            liquidstake_1.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = liquidstake_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseMsgUpdateParams();
        if ((0, helpers_1.isSet)(object.authority))
            obj.authority = String(object.authority);
        if ((0, helpers_1.isSet)(object.params))
            obj.params = liquidstake_1.Params.fromJSON(object.params);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? liquidstake_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        if (object.params !== undefined && object.params !== null) {
            message.params = liquidstake_1.Params.fromPartial(object.params);
        }
        return message;
    },
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
exports.MsgUpdateParamsResponse = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseMsgUpdateParamsResponse();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
};
function createBaseMsgUpdateWhitelistedValidators() {
    return {
        authority: "",
        whitelistedValidators: [],
    };
}
exports.MsgUpdateWhitelistedValidators = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        for (const v of message.whitelistedValidators) {
            liquidstake_1.WhitelistedValidator.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateWhitelistedValidators();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.whitelistedValidators.push(liquidstake_1.WhitelistedValidator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseMsgUpdateWhitelistedValidators();
        if ((0, helpers_1.isSet)(object.authority))
            obj.authority = String(object.authority);
        if (Array.isArray(object?.whitelistedValidators))
            obj.whitelistedValidators = object.whitelistedValidators.map((e) => liquidstake_1.WhitelistedValidator.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        if (message.whitelistedValidators) {
            obj.whitelistedValidators = message.whitelistedValidators.map((e) => e ? liquidstake_1.WhitelistedValidator.toJSON(e) : undefined);
        }
        else {
            obj.whitelistedValidators = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateWhitelistedValidators();
        message.authority = object.authority ?? "";
        message.whitelistedValidators =
            object.whitelistedValidators?.map((e) => liquidstake_1.WhitelistedValidator.fromPartial(e)) || [];
        return message;
    },
};
function createBaseMsgUpdateWhitelistedValidatorsResponse() {
    return {};
}
exports.MsgUpdateWhitelistedValidatorsResponse = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateWhitelistedValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseMsgUpdateWhitelistedValidatorsResponse();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateWhitelistedValidatorsResponse();
        return message;
    },
};
function createBaseMsgSetModulePaused() {
    return {
        authority: "",
        isPaused: false,
    };
}
exports.MsgSetModulePaused = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.isPaused === true) {
            writer.uint32(16).bool(message.isPaused);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetModulePaused();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.isPaused = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseMsgSetModulePaused();
        if ((0, helpers_1.isSet)(object.authority))
            obj.authority = String(object.authority);
        if ((0, helpers_1.isSet)(object.isPaused))
            obj.isPaused = Boolean(object.isPaused);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.isPaused !== undefined && (obj.isPaused = message.isPaused);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgSetModulePaused();
        message.authority = object.authority ?? "";
        message.isPaused = object.isPaused ?? false;
        return message;
    },
};
function createBaseMsgSetModulePausedResponse() {
    return {};
}
exports.MsgSetModulePausedResponse = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetModulePausedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseMsgSetModulePausedResponse();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSetModulePausedResponse();
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.LiquidStake = this.LiquidStake.bind(this);
        this.LiquidUnstake = this.LiquidUnstake.bind(this);
        this.StakeToLP = this.StakeToLP.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.UpdateWhitelistedValidators = this.UpdateWhitelistedValidators.bind(this);
        this.SetModulePaused = this.SetModulePaused.bind(this);
    }
    LiquidStake(request) {
        const data = exports.MsgLiquidStake.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstake.v1beta1.Msg", "LiquidStake", data);
        return promise.then((data) => exports.MsgLiquidStakeResponse.decode(new binary_1.BinaryReader(data)));
    }
    LiquidUnstake(request) {
        const data = exports.MsgLiquidUnstake.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstake.v1beta1.Msg", "LiquidUnstake", data);
        return promise.then((data) => exports.MsgLiquidUnstakeResponse.decode(new binary_1.BinaryReader(data)));
    }
    StakeToLP(request) {
        const data = exports.MsgStakeToLP.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstake.v1beta1.Msg", "StakeToLP", data);
        return promise.then((data) => exports.MsgStakeToLPResponse.decode(new binary_1.BinaryReader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstake.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new binary_1.BinaryReader(data)));
    }
    UpdateWhitelistedValidators(request) {
        const data = exports.MsgUpdateWhitelistedValidators.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstake.v1beta1.Msg", "UpdateWhitelistedValidators", data);
        return promise.then((data) => exports.MsgUpdateWhitelistedValidatorsResponse.decode(new binary_1.BinaryReader(data)));
    }
    SetModulePaused(request) {
        const data = exports.MsgSetModulePaused.encode(request).finish();
        const promise = this.rpc.request("pstake.liquidstake.v1beta1.Msg", "SetModulePaused", data);
        return promise.then((data) => exports.MsgSetModulePausedResponse.decode(new binary_1.BinaryReader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
//# sourceMappingURL=tx.js.map